export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L0_solid_x_01_f.8fcc4d39.png";